import { render, staticRenderFns } from "./VidaSoftware.vue?vue&type=template&id=6f188d2e&scoped=true&"
import script from "./VidaSoftware.vue?vue&type=script&lang=js&"
export * from "./VidaSoftware.vue?vue&type=script&lang=js&"
import style0 from "./VidaSoftware.vue?vue&type=style&index=0&id=6f188d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f188d2e",
  null
  
)

export default component.exports